import { render } from "./ProfileDropdownItem.vue?vue&type=template&id=5e43f7ce&scoped=true"
import script from "./ProfileDropdownItem.vue?vue&type=script&lang=js"
export * from "./ProfileDropdownItem.vue?vue&type=script&lang=js"

import "./ProfileDropdownItem.vue?vue&type=style&index=0&id=5e43f7ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e43f7ce"]])

export default __exports__